import { Injectable } from '@angular/core';
import { CommunicatorService } from '../common/services/communicator.service';
import { API_CURRENT_VERSION, EndPointBaseUrl } from '../common/settings/settings';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private communicatorService: CommunicatorService) { 
    
  }

  logOut() {
    return this.communicatorService.postData(EndPointBaseUrl + API_CURRENT_VERSION + "/session/logout", null)
  }
}
